/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { Input, Icon } from '@fiverr-private/fit';
import { r_search } from '@fiverr-private/icons';
import { ComboBox } from '@fiverr-private/orca';
import { grey_900 } from '@fiverr-private/sass/helpers/index';
import { COPIES } from '../../../../constants';

import { DEPARTMENT_KEYS, LOCATION_KEYS } from '../../../../../shared/comeet/comeet_api/constants';
import styles from './styles.module.scss';

export const Filters = ({ setSearchTerm, setTeam, defaultLocation, setLocation, showTeam }) => {
    const teams = useMemo(
        () =>
            Object.keys(DEPARTMENT_KEYS).map((key) => ({
                value: key,
                label: COPIES.teams[DEPARTMENT_KEYS[key]],
            })),
        []
    );

    const locations = useMemo(
        () =>
            Object.keys(LOCATION_KEYS).map((key) => ({
                value: key,
                label: key,
            })),
        []
    );

    return (
        <div className={styles.filter}>
            <div className={styles.dropdowns}>
                FILTER BY:
                {showTeam ? (
                    <ComboBox
                        placeholder={COPIES.filters.allTeams}
                        isMulti={false}
                        isClearable
                        onChange={(e) => setTeam(e?.value || '')}
                        className={styles.dropdownComponent}
                        options={teams}
                    />
                ) : null}
                <ComboBox
                    placeholder={COPIES.filters.allLocations}
                    isMulti={false}
                    isClearable
                    onChange={(e) => setLocation(e?.value || '')}
                    defaultValue={defaultLocation ? { value: defaultLocation, label: defaultLocation } : undefined}
                    className={styles.dropdownComponent}
                    options={locations}
                />
            </div>
            <div>
                <Input
                    placeholder={COPIES.filters.search}
                    className={styles.search}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    icon={
                        <Icon size={16} color={grey_900}>
                            {r_search}
                        </Icon>
                    }
                />
            </div>
        </div>
    );
};
